import type { AuthConfigResponse } from "@checklist/shared";

export type RegisterView = "signup" | "request" | "closed";

/**
 * Which register screen to show. A failed config fetch (`null`) and an invited
 * arrival both fall through to the sign-up form; PreSignUp still enforces mode.
 */
export function registerView(
  mode: AuthConfigResponse["signupMode"] | null,
  invited: boolean
): RegisterView {
  if (invited || mode === null || mode === "open") return "signup";
  if (mode === "invite-only") return "request";
  return "closed";
}

/** Tab-title segment for /register; `null` while the sign-up mode loads (D9). */
export function registerTitle(view: RegisterView | null): string {
  if (view === "request") return "Request access";
  if (view === "closed") return "Sign-up is closed";
  if (view === "signup") return "Create account";
  return "Sign up";
}
